<template>
  <FoodArtworkLayout :head-title="headTitle">
    <template v-slot:imageSlot>
      <div class="box-custom-image2" ref="imageDom">
        <img class="image-food" ref="imgFood" :src="imgSrc ? imgSrc : image" alt="">
        <div class="content-top">
          <img class="logo" ref="imgLogo" src="@/assets/img/background/Frame-2946.png" alt="">
          <div class="box-detail1" id="discount">
            <gen-right-center-component :inputText="qtyText" :previewOptions="qtyOptions" :previewVertOffset="qtyOptions.previewVertOffset"></gen-right-center-component>
            <gen-right-top-component :inputText="menuText+priceText" :previewOptions="menuOptions" :previewVertOffset="previewVertOffset"></gen-right-top-component>
            <div class="clear"></div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="box-detail1">
            <gen-left-icon-component :inputText1="storeText1" :inputText2="storeText2" :inputText3="branchText" :previewOptions="storeOptions1" :textLeft="textLeft" :isIcon="isIcon" :fixText="fixText"></gen-left-icon-component>
          </div>
          <div class="box-logo-qr">
            <img class="logo-bt" src="@/assets/img/icons/Frame-2952.png" alt=""/>
            <div class="box-qr">
              <p>{{ $t('ORDER_NOW') }}</p>
              <qrcode-vue className="box-qr-inside" :value="qrResult" :size="qrCodeSize" level="L" />
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div :class="['overlay fil', shadowImageClass]" ref="imgOverlay"></div>
      </div>

      <div class="box-custom-image2-mobile" ref="imageDom_m">
        <img class="image-food" ref="imgFood_m" :src="imgSrc ? imgSrc : image" alt="">
        <div class="content-top">
          <img class="logo" ref="imgLogo_m" src="@/assets/img/background/Frame-2946.png" alt="">
          <div class="box-detail1" id="discount">
            <gen-right-center-component :inputText="qtyText" :previewOptions="qtyOptionsm" :previewVertOffset="qtyOptionsm.previewVertOffset"></gen-right-center-component>
            <gen-right-top-component :inputText="menuText+priceText" :previewOptions="menuOptionsm" :previewVertOffset="previewVertOffsetm"></gen-right-top-component>
            <div class="clear"></div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="box-detail1">
            <gen-left-icon-component :inputText1="storeText1" :inputText2="storeText2" :inputText3="branchText" :previewOptions="storeOptions1m" :textLeft="textLeftm" :isIcon="isIcon" :fixText="fixTextm"></gen-left-icon-component>
          </div>
          <div class="box-logo-qr">
            <img class="logo-bt" src="@/assets/img/icons/Frame-2952.png" alt=""/>
            <div class="box-qr">
              <p>{{ $t('ORDER_NOW') }}</p>
              <qrcode-vue className="box-qr-inside-m" ref="qr_custom" :value="qrResult" :size="qrCodeSizeM" level="L"></qrcode-vue>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div :class="['overlay fil', shadowImageClass]" ref="imgOverlay_m"></div>
      </div>
    </template>
    <template v-slot:formSlot>
      <div class="box-form">
        <input type="file" @change="onFileChanged" class="hidden-files" ref="addFile">
        <button class="btn-color change-pic" @click="onUpload">{{ btn_upload_label }}</button>

        <div class="box-input-add">
          <div class="container-box-input">
            <div class="box-label">
              <label class="label-left">{{ $t('MERCHANT_NAME') }}</label>
              <label class="label-right">
                <span v-text="storeText1.length"></span><span ref="maximum_store">{{ `/${ $t('MERCHANT_NAME_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('MERCHANT_NAME_LIMIT')"
                v-model="storeText1"
                :placeholder="$t('INSERT_MERCHANT_NAME_LABEL')"
              />
            </div>
          </div>
          <div class="box-add" v-if="isShow">
            <div class="plus-icon" @click="add_store_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('ADD_LINE_LABEL') }}</p>
          </div>
        </div>
        <div class="box-input-add" v-if="storebox2">
          <div class="container-box-input">
            <div class="box-label" >
              <label class="label-left">{{ $t('MERCHANT_LINE_2_NAME') }}</label>
              <label class="label-right">
                <span v-text="storeText2.length"></span><span ref="maximum_store">{{ `/${ $t('MERCHANT_NAME_LINE_2_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('MERCHANT_NAME_LINE_2_LIMIT')"
                v-model="storeText2"
                :placeholder="$t('INSERT_MERCHANT_NAME_LABEL')"
              />
            </div>
          </div>
          <div class="box-remove">
            <div class="remove-icon" @click="rm_store_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('REMOVE_LINE_LABEL') }}</p>
          </div>
        </div>

        <div class="box-label">
          <label class="label-left">{{ $t('BRANCH_NAME_OPTIONAL') }}</label>
          <label class="label-right">
            <span v-text="branchText.length"></span><span ref="maximum_branch">{{ `/${ $t('BRANCH_NAME_LIMIT') }` }}</span>
          </label>
        </div>
        <div class="border-linear">
          <input type="text" :maxlength="$t('BRANCH_NAME_LIMIT')" v-model="branchText" :placeholder="$t('INSERT_BRANCH_NAME_LABEL')"/>
        </div>
        <div class="container-qty">
          <div class="half-one">
            <div class="box-label">
              <label class="label-left">{{ $t('DISCOUNT_AMOUNT') }}</label>
            </div>
            <div class="border-linear">
              <input type="text" v-model="quantity" @input="handleChange" onkeypress='return event.charCode >= 48 && event.charCode <= 57' :placeholder="$t('INSERT_DISCOUNT_AMOUNT')" />
            </div>
          </div>
          <div class="half-two">
            <div class="box-label">
              <label class="label-left">{{ $t('UNIT') }}</label>
            </div>
            <div class="border-linear">
              <select v-model="unit" @change="handleChange_unit">
                <option>{{ $t('PERCENT') }}</option>
                <option value=".-">{{ $t('CURRENCY') }}</option>
              </select>
            </div>
          </div>

          <div class="clear"></div>
        </div>
        <div class="box-label">
          <label class="label-left">{{  $t('MENU_NAME') }}</label>
          <label class="label-right">
            <span v-text="menuText.length"></span><span ref="maximum_menu">{{ `/${$t('MENU_NAME_LIMIT')}` }}</span>
          </label>
        </div>
        <div class="border-linear">
          <input type="text" :maxlength="$t('MENU_NAME_LIMIT')" v-model="menuText" :placeholder="$t('INSERT_MENU_NAME')"/>
        </div>

        <div class="box-label" >
          <label class="label-full">{{ $t('NET_PRICE_OPTIONAL') }}</label>
        </div>
        <div class="border-linear">
          <input type="text" v-model="price" :placeholder="$t('INSERT_NET_PRICE')" onkeypress='return event.charCode >= 48 && event.charCode <= 57'/>
        </div>

        <div class="box-label">
          <label class="label-full">{{  $t('MERCHANT_CODE_FOR_QR_LABEL') }}</label>
        </div>
        <div class="border-linear qr-code-input">
          <input type="text" v-model="qrcode_text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' :placeholder="$t('INSERT_MERCHANT_CODE_LABEL')"/>
          <img class="icon-info" id="icon-info" src="@/assets/img/icons/dshop.png" alt="" @click="toggleIntroducePopup"/>
        </div>

        <div class="back" id="open_update" @click="toggleBackPopup">
          <div><p>{{ $t('BACK_LABEL') }}</p></div>
        </div>
        <button class="btn-color save-pic" ref="save_pic" @click="toImage">{{ $t('SAVE_IMAGE_LABEL') }}</button>

        <div :class="['popup-saved', 'animatedFadeInUp', 'animated', savedPopupClass]" id="popup-saved">
          <p>{{ $t('SAVE_IMAGE_ALREADY_LABEL') }}</p>
          <img src="@/assets/img/icons/akar-icons_circle-check.png" alt=""/>
        </div>
        <div :class="['popup-back', backPopupClass]">
          <BackPopup :toggleBackPopup="toggleBackPopup" />
        </div>
        <div :class="['popup-info-pass', introducePopupClass]">
          <InfoPopup :toggleIntroducePopup="toggleIntroducePopup" />
        </div>

      </div>
    </template>
  </FoodArtworkLayout>
</template>

<script>
import FoodArtworkLayout from '@/layouts/FoodArtworkLayout.vue';
import {
  blankMerchantUrl, merchantUrl, qrCodeFoodSize, qrCodeFoodSizeM,
} from '@/config/enum';
import { generateImageAndDownload, thousandSeparator } from '@/utils';
import InfoPopup from '@/components/Popup/InfoPopup.vue';
import BackPopup from '@/components/Popup/BackPopup.vue';
import generateTextRightCenter from '@/components/GenerateText/GenerateTextRightCenter.vue';
import generateTextLeftIcon from '@/components/GenerateText/GenerateTextLeftIcon.vue';
import generateTextRightTop from '@/components/GenerateText/GenerateTextRightTop.vue';
import bgEmpty from '@/assets/img/background/BG_empty.png';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'FoodDiscount',
  metaInfo: {
    title: 'Food Discount',
  },
  components: {
    QrcodeVue,
    FoodArtworkLayout,
    InfoPopup,
    BackPopup,
    genLeftIconComponent: generateTextLeftIcon,
    genRightCenterComponent: generateTextRightCenter,
    genRightTopComponent: generateTextRightTop,
  },
  props: {
    headTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imgSrc: '',
      imgSrcName: 'RBH_shop.jpg',
      isIcon: 'location',
      fixText: '',
      fixTextm: '',
      storeText1: '',
      storeText2: '',
      branchText: '',
      storeOptions1: {
        safeWidth: 700,
        previewHeight: 120,
        previewVertOffset: 0,
        originalFontSize: 90,
        fontSize: 20,
        mgLine2: 5,
        mgLine3: 10,
      },
      storeOptions1m: {
        safeWidth: 120,
        previewHeight: 20,
        previewVertOffset: 0,
        originalFontSize: 14,
        fontSize: 11,
        mgLine2: 0,
        mgLine3: 4,
      },

      quantity: '',
      price: '',
      unit: '%',
      qtyOptions: {
        safeWidth: 700,
        previewHeight: 300,
        previewVertOffset: -10,
        originalFontSize: 216,
      },
      qtyOptionsm: {
        safeWidth: 390,
        previewHeight: 180,
        previewVertOffset: -10,
        originalFontSize: 120,
      },

      menuText: '',
      menuOptions: {
        safeWidth: 1140,
        previewHeight: 120,
        previewVertOffset: 85,
        originalFontSize: 90,
      },
      menuOptionsm: {
        safeWidth: 200,
        previewHeight: 20,
        previewVertOffset: 45,
        originalFontSize: 16,
      },

      textLeft: 25,
      textLeftm: 5,

      image: bgEmpty,
      btn_upload_label: 'อัพโหลดรูปภาพ',
      qrcode_text: '',
      qrCodeSize: qrCodeFoodSize,
      qrCodeSizeM: qrCodeFoodSizeM,
      storebox2: false,
      isShow: true,
      isShowBackPopup: false,
      isShowSavedPopup: false,
      isShowIntroducePopup: false,
      isShowShadow: false,
    };
  },
  computed: {
    qrResult() {
      if (this.qrcode_text !== '') {
        return merchantUrl(this.qrcode_text);
      }
      return blankMerchantUrl;
    },
    qtyText() {
      if (this.quantity !== '') { return `ลด ${thousandSeparator(this.quantity)}${this.unit}`; }
      return '';
    },
    priceText() {
      if (this.price !== '') { return `\nเพียง ${thousandSeparator(this.price)}.-`; }
      return '';
    },
    previewVertOffset() {
      if (this.qtyText !== '') { return this.menuOptions.previewVertOffset; }
      return this.qtyOptions.previewVertOffset + 25;
    },
    previewVertOffsetm() {
      if (this.qtyText !== '') { return this.menuOptionsm.previewVertOffset; }
      return this.qtyOptionsm.previewVertOffset + 20;
    },
    backPopupClass() {
      return this.isShowBackPopup ? 'popup-show' : '';
    },
    savedPopupClass() {
      return this.isShowSavedPopup ? 'fadeInUp' : '';
    },
    introducePopupClass() {
      return this.isShowIntroducePopup ? 'popup-show' : '';
    },
    shadowImageClass() {
      return this.isShowShadow ? 'format-overlay-discount' : '';
    },
  },
  methods: {
    add_store_row() {
      this.storebox2 = true;
      this.isShow = false;
    },
    rm_store_row() {
      this.storebox2 = false;
      this.storeText2 = '';
      this.isShow = true;
    },
    handleChange() {
      if (this.quantity === 0) {
        this.quantity = '';
      } else {
        if (this.quantity < 0) { this.quantity = 0; }
        if (this.quantity > 100 && this.unit !== '.-') {
          this.quantity = 100;
        }
      }
    },
    handleChange_unit() {
      if (this.unit !== '.-' && this.quantity > 100) {
        this.quantity = 100;
      }
    },

    toggleIntroducePopup() {
      this.isShowIntroducePopup = !this.isShowIntroducePopup;
    },
    toggleBackPopup() {
      this.isShowBackPopup = !this.isShowBackPopup;
    },
    onFileChanged(e) {
      this.btn_upload_label = this.$t('CHANGE_IMAGE_LABEL');
      this.isShowShadow = true;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      // const image = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        const image = e.target && e.target.result ? e.target.result : '';
        if (typeof image === 'string') {
          this.imgSrc = image;
          this.imgSrcName = file.name;
        }
      };

      reader.readAsDataURL(file);
    },
    toImage() {
      if (window.innerWidth <= 767) {
        const imageNode = this.$refs.imageDom_m;
        this.generateImageAndDownload(imageNode, 400);
      } else {
        const imageNode = this.$refs.imageDom;
        this.generateImageAndDownload(imageNode, 1200);
      }
    },
    onSave() {
      this.isShowSavedPopup = true;
      setTimeout(() => {
        this.isShowSavedPopup = false;
      }, 3000);
    },
    generateImageAndDownload(imageNode, size) {
      generateImageAndDownload(imageNode, size, this.imgSrcName, this.onSave);
    },
    onUpload() {
      this.$refs.addFile.click();
    },
  },
};
</script>

<style scoped>

</style>
